import { HttpErrorResponse } from '@angular/common/http';

export interface RetryParams {
  attempts: number;
  delay: number;
  shouldRetry: (error: HttpErrorResponse) => boolean;
  endpoint?: string;
}

export const defaultParams: RetryParams = {
  attempts: 3,
  delay: 500,
  shouldRetry: ({ status }) => status >= 500 || status === 0,
};

export const retryEndpointsList = [
  {
    ...defaultParams,
    endpoint: 'Config/GetBaseConfig',
  },
  {
    ...defaultParams,
    endpoint: 'Config/GetClientConfig',
  },
];
